<template>
    <div>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <template v-for="(matches, date) in groupedMatches">
                    <v-flex xs12>
                        <div class="title mb-2">{{ date }}</div>
                        <v-divider></v-divider>
                    </v-flex>
                    <v-container class="matches-container mb-4">
                        <v-layout row wrap justify-start>
                            <template v-for="match in matches">
                                <v-flex xs12 sm6 md6 lg4>
                                    <v-card class="mb-2">
                                        <template v-if="match.location_id && getLocation(match.location_id)">
                                            <v-card-title primary-title style="padding-bottom: 0px !important;">
                                                <div class="subheading font-weight-bold">{{ match.match_moment.format('ddd MMM D') }}</div>
                                                <v-spacer></v-spacer>
                                                <div class="subheading font-weight-bold">{{ match.match_moment.format('h:mm a') }}</div>
                                            </v-card-title>
                                            <v-card-title primary-title style="padding-top: 0px !important;">
                                                <div class=" body-1">@{{ getLocation(match.location_id).location }}</div>
                                            </v-card-title>
                                        </template>
                                        <template v-else>
                                            <v-card-title primary-title>
                                                <div class="subheading font-weight-bold">{{ match.match_moment.format('ddd MMM D') }}</div>
                                                <v-spacer></v-spacer>
                                                <div class="subheading font-weight-bold">{{ match.match_moment.format('h:mm a') }}</div>
                                            </v-card-title>
                                        </template>
                                        <v-divider></v-divider>
                                        <v-list dense>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <team-badge v-bind:team="getTeam(match.away_team_id).team"
                                                        v-bind:colour="getTeam(match.away_team_id).colour"
                                                        width="120px"></team-badge>
                                                </v-list-tile-content>
                                                <v-list-tile-content class="align-end font-weight-bold">{{ match.game_played ?
                                                    match.away_team_score : 'TBD' }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <team-badge v-bind:team="getTeam(match.home_team_id).team"
                                                        v-bind:colour="getTeam(match.home_team_id).colour"
                                                        width="120px"></team-badge>
                                                </v-list-tile-content>
                                                <v-list-tile-content class="align-end font-weight-bold">{{ match.game_played ?
                                                    match.home_team_score : 'TBD' }}</v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                        <v-divider></v-divider>
                                        <v-card-actions v-if="is_admin()">
                                            <v-btn flat small color="warning"
                                                v-bind:to="{name: 'admin_matches_edit', params: {id: match.id}}">Edit</v-btn>
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn flat small color="error" v-on="on">Delete</v-btn>
                                                </template>
                                                <v-list>
                                                    <v-btn flat small color="error" v-on:click="issueDelete(match)">Really
                                                        Delete?</v-btn>
                                                </v-list>
                                            </v-menu>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-container>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'MatchesGrid',
    props: ['groupedMatches', 'admin'],
    methods: {
        issueDelete(match) {
            this.$store.dispatch('deleteMatch', match)
        },
        getTeam(team_id) {
            let team = this.$store.getters.getTeamById(team_id)
            if (team) {
                return team
            }
        },
        getLocation(location_id) {
            let location = this.$store.getters.getLocationById(location_id)
            if (location) {
                return location
            }
        },
        is_admin() {
            if (this.admin) {
                return true
            } else {
                return false
            }
        }
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
